import React, { useState } from 'react';
import { Button } from '@radix-ui/themes';
import SOSDialog from './SOSDialog';

const SOSButton = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleSOSClick = () => {
    setIsDialogOpen(true);
  };

  return (
    <>
      <Button
        onClick={handleSOSClick}
        size="3"
        className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3 rounded-lg shadow-lg transition-all duration-200 transform hover:scale-105"
        style={{
          backgroundColor: '#dc2626',
          border: '2px solid #b91c1c',
          boxShadow: '0 4px 12px rgba(220, 38, 38, 0.3)',
          minWidth: '120px'
        }}
      >
        SOS
      </Button>

      <SOSDialog 
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
};

export default SOSButton;